<div *ngIf="!smallInput">
  <div
    class="dropzone form-control my-2"
    [ngClass]="{ 'image-displaying': url.length, deletble: isDeletble }"
  >
    <input
      type="file"
      #fileDropRef
      class="form-control my-2"
      *ngIf="url.length == 0"
      [multiple]="singleImage"
      (change)="onImageSelection($event)"
    />
    <div class="d-flex" *ngIf="url.length; else noImage">
      <div
        class="rounded border border-1 p-2"
        style="width: 90px; height: 72px"
      >
        <input
          type="file"
          #fileDropRef
          class="form-control my-2"
          [multiple]="singleImage"
          [ngStyle]="{ width: width, height: height }"
          (change)="onImageSelection($event)"
        />
        <div class="d-flex flex-column justify-content-center w-100">
          <svg-icon [src]="icon"></svg-icon>
          <div class="d-flex flex-column justify-content-center">
            <p class="text-secondary fs-13">
              {{ text3 }}
            </p>
          </div>
        </div>
      </div>
      <div
        class="rounded mx-2 d-flex image-container"
        [ngStyle]="{ width: imageContainerWidth }"
      >
        @for (item of url; track $index) {
          <div *ngIf="item">
            <img
              *ngIf="item"
              [src]="displayImg(item)"
              class="rounded mx-2"
              (click)="openImage(displayImg(item))"
            />
            <div class="middle">
              <svg-icon
                [src]="'/assets/icons/trash.svg'"
                style="position: relative; top: 10px"
                class="cursor-pointer"
                (click)="deleteImage($index)"
              ></svg-icon>
            </div>
          </div>
        }
      </div>
    </div>
    <ng-template #noImage>
      <div class="d-flex flex-column justify-content-center">
        <svg-icon [src]="icon"></svg-icon>
        <div class="d-flex flex-column justify-content-center">
          <p class="text-secondary fs-13">
            {{ text1 }}
            <label class="me-1">{{ text2 }}</label>
          </p>
        </div>
      </div>
    </ng-template>
  </div>
</div>

<div *ngIf="smallInput">
  <div
    class="dropzone form-control my-2"
    [ngClass]="{
      'image-displaying': url.length || smallInput,
      deletble: isDeletble
    }"
  >
    <input
      type="file"
      #fileDropRef
      class="form-control my-2"
      *ngIf="url?.length == 0"
      [multiple]="singleImage"
      (change)="onImageSelection($event)"
    />
    <div class="d-flex" *ngIf="url?.length || smallInput; else noImage">
      <div
        class="{{ innerClass }} position-relative single-image-container"
        [ngStyle]="{
          width: width + 'px',
          height: height + 'px',
          backgroundImage: forProfile ? 'url(' + displayImg(url[0]) + ')' : ''
        }"
      >
        @if(!forProfile){
          <img
            [src]="displayImg(url[0])"
            style="object-fit: contain"
            class="w-100 h-100"
            *ngIf="url[0]"
            alt=""
          />
        }

        <input
          type="file"
          #fileDropRef
          class="form-control my-2"
          [multiple]="singleImage"
          *ngIf="!url?.length"
          [ngStyle]="{ width: width, height: height }"
          (change)="onImageSelection($event)"
        />
        <div
          class="d-flex flex-column justify-content-center w-100 py-px-20"
          *ngIf="singleImage && !url?.length"
        >
          <svg-icon [src]="icon"></svg-icon>
          <div class="d-flex flex-column justify-content-center">
            <p class="text-secondary fs-13">
              {{ text3 }}
            </p>
          </div>
        </div>
        <div
          class="middle-single-image"
          (click)="deleteImage(0)"
          *ngIf="smallInput && url?.length"
        >
          <svg-icon
            [src]="'/assets/icons/trash.svg'"
            style="position: relative"
            class="cursor-pointer"
          ></svg-icon>
        </div>
      </div>

      <div
        class="rounded mx-2 d-flex image-container"
        [ngStyle]="{ width: imageContainerWidth }"
        *ngIf="!smallInput"
      >
        @for (item of url; track $index) {
          <div *ngIf="!smallInput && !!item">
            <img
              *ngIf="item"
              [src]="'data:image/jpeg;base64,' + item"
              class="rounded mx-2"
            />
            <div class="middle" (click)="deleteImage($index)">
              <svg-icon
                [src]="'/assets/icons/trash.svg'"
                style="position: relative; top: 10px"
                class="cursor-pointer"
              ></svg-icon>
            </div>
          </div>
        }
      </div>
    </div>

    <ng-template #noImage>
      <div class="d-flex flex-column justify-content-center">
        <svg-icon [src]="icon"></svg-icon>
        <div class="d-flex flex-column justify-content-center">
          <p class="text-secondary fs-13">
            {{ text1 }}
            <label class="me-1">{{ text2 }}</label>
          </p>
        </div>
      </div>
    </ng-template>
  </div>
</div>
<div *ngIf="messageError" class="required">{{ messageError }}</div>

